const users = {
  inactive: '#C4C4C4',
  admin: '#2E5755',
  client: '#5C3E54',
  vendor: '#6B4539'
};

export default users;
